module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/16-2415a839f8c287c96d18d965c7f80d9e.jpg";